// extracted by mini-css-extract-plugin
module.exports = {"text":"TextComponent_text__2XnUK"};